'use client'

import dayjs from 'dayjs'

import { getTranslate } from '@/legacy-src/utilities/i18n'

const ReviewsDataHeader: React.FC = () => {
  const { t } = getTranslate()

  return (
    <div className="flex justify-center">
      <span className="mb-8 mt-6 rounded-full bg-blue-500 p-3 text-sm font-bold text-petrol-500">
        {t('component.reviews.reviewsFrom', { date: dayjs().format('DD. MM. YYYY') })}
      </span>
    </div>
  )
}

export default ReviewsDataHeader
